<template>
    <div class="login-container" style="width: 100%;display:flex;">
        <div id="captcha" style="margin-left: auto;margin-right: auto;"></div>
    </div>

</template>

<script>
import './gt4.js'

export default {
    name: 'Login',
    data() {
        return {
            captchaDialog: false,
            captchaObj: null,
            captcha: null
        }
    },
    methods: {
        init() {
            initGeetest4({
                // captchaId: '97232407755cf3586e8f6e9546854406',
                captchaId: '437b82702adcd5ce465c602fd59c95b2',
                product: "popup"
            }, (captcha) => {
                captcha.onReady(() => {
                    this.captcha = captcha;
                      // 验证码加载完毕的回调
                });
                captcha.onSuccess(() => {
                    var result = captcha.getValidate();
                    this.captchaObj = result;
                    // this.$emit("captchaSuccess", result, captcha);
                    console.log(this.captchaObj);
                })
                // captcha为验证码实例
                captcha.appendTo("#captcha");// 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>